import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
/**
 * The Audio Layer.
 *
 * Two decisions, both from the script and both about learners on bad
 * connections:
 *
 *  1. **The transcript is the content; the recording is a rendering of it.**
 *     `narration.transcript` is required in the DSL and `assetId` is not, so a
 *     lab whose audio has not been recorded yet still teaches. The transcript
 *     is shown by default rather than behind a toggle — a transcript that
 *     appears only when you press play is useless to a learner who will never
 *     press play because they are paying for the megabyte.
 *
 *  2. **Never autoplay unless the script asks.** Audio that starts by itself on
 *     a shared phone in a classroom is a discipline problem, and on metered
 *     data it is a bill.
 */
export function NarrationPlayer({ step, tier, transcriptAlways, volume, src, }) {
    const audioRef = useRef(null);
    const [showTranscript, setShowTranscript] = useState(transcriptAlways);
    const [failed, setFailed] = useState(false);
    useEffect(() => {
        if (audioRef.current)
            audioRef.current.volume = volume;
    }, [volume, src]);
    useEffect(() => {
        // A new step is a new narration. Stopping the old one is the difference
        // between guidance and two voices talking over each other.
        audioRef.current?.pause();
        setFailed(false);
    }, [step.id]);
    // At the text tier the audio is not offered at all. Someone on 2G with Data
    // Saver on has told us not to fetch a media file, and a play button that
    // stalls for forty seconds is worse than no play button.
    const offerAudio = src !== null && tier !== 'text' && !failed;
    return (_jsxs("section", { className: "lab-narration", "aria-label": "Audio guidance", children: [_jsxs("div", { className: "lab-narration__bar", children: [_jsx("span", { className: "lab-narration__icon", "aria-hidden": "true", children: "\uD83D\uDD0A" }), _jsx("h3", { className: "lab-narration__title", children: "Audio guidance" }), offerAudio && (_jsx("audio", { ref: audioRef, src: src ?? undefined, controls: true, preload: "none", className: "lab-narration__audio", onError: () => setFailed(true), children: _jsx("track", { kind: "captions" }) })), !transcriptAlways && (_jsx("button", { type: "button", className: "lab-link", "aria-expanded": showTranscript, onClick: () => setShowTranscript(current => !current), children: showTranscript ? 'Hide transcript' : 'Show transcript' }))] }), (showTranscript || transcriptAlways) && (_jsx("p", { className: "lab-narration__transcript", children: step.narration.transcript }))] }));
}
//# sourceMappingURL=NarrationPlayer.js.map